import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Mail, Trash2 } from "lucide-react";
import { fmtDate } from "@/lib/dates";

export default function PendingInvites({ invites, onChanged }) {
  const revoke = async (email) => {
    if (!window.confirm(`Revoke invite for ${email}?`)) return;
    await api.delete(`/invites/${email}`);
    onChanged?.();
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <Mail size={14} className="text-slate-500" />
        <h2 className="text-sm font-semibold" style={{ fontFamily: "Outfit" }}>Pending Invites</h2>
        <span className="text-xs text-slate-400 font-mono-data">({invites.length})</span>
      </div>
      <div className="border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200 text-[11px] uppercase tracking-wider text-slate-500">
            <tr>
              <th className="text-left px-4 py-2.5">Email</th>
              <th className="text-left px-4 py-2.5">Name</th>
              <th className="text-left px-4 py-2.5">Role</th>
              <th className="text-left px-4 py-2.5">Sent</th>
              <th className="px-4 py-2.5 w-12"></th>
            </tr>
          </thead>
          <tbody>
            {invites.length === 0 && <tr><td colSpan={5} className="px-4 py-6 text-center text-xs text-slate-400">No pending invites</td></tr>}
            {invites.map((inv) => (
              <tr key={inv.email} className="border-b border-slate-100" data-testid={`invite-row-${inv.email}`}>
                <td className="px-4 py-2.5 font-mono-data text-xs text-[#0a2540]">{inv.email}</td>
                <td className="px-4 py-2.5 text-xs">{inv.name || "—"}</td>
                <td className="px-4 py-2.5 text-xs">{inv.role}</td>
                <td className="px-4 py-2.5 text-xs font-mono-data text-slate-500">{fmtDate(inv.created_at)}</td>
                <td className="px-4 py-2.5 text-right">
                  <Button size="sm" variant="ghost" className="text-red-600 h-7 w-7 p-0" onClick={() => revoke(inv.email)} data-testid={`btn-revoke-${inv.email}`}>
                    <Trash2 size={12} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
